import { PropsWithChildren, useCallback, useEffect, useState } from "react";
import { container } from "tsyringe";
import { useProjectId } from "hooks/useProjectId";
import ProjectService from "services/ProjectService";
import assert from "assert";

export type IProps = PropsWithChildren<{
	/**
	 * The component to display when the user has no right
	 */
	onNoRightComponent?: React.ReactNode | undefined;
	/**
	 * The callback to call when the user has not the right
	 */
	onNoRight?: () => Promise<void> | void | undefined;
}>;

const projectService = container.resolve(ProjectService);

export default function RequireIsProjectOwner({ onNoRight, onNoRightComponent, children }: IProps) {
	const { projectId } = useProjectId();
	const [userIsProjectOwner, setUserIsProjectOwner] = useState(false);

	const checkIsProjectOwner = useCallback(async () => {
		return projectService.isOwner(projectId).then(({ isOwner }) => isOwner);
	}, [projectId]);

	useEffect(() => {
		checkIsProjectOwner().then((isOwner) => {
			setUserIsProjectOwner(isOwner);
			if (!isOwner) onNoRight?.();
		});
	}, [onNoRight, checkIsProjectOwner, userIsProjectOwner]);

	assert(projectId, "projectId is required");

	if (!userIsProjectOwner) return onNoRightComponent;

	return <>{children}</>;
}
